<template lang="html">
  <div class="activity-block">
    <img :src="activityImg" />
  </div>
</template>

<script>
  export default {
    data: function(){
      return {
          activityImg: "../../static/images/activity.png"
      }
    }
  }
</script>

<style lang="scss">
  .activity-block{
    padding: .02rem 0;
    img{
      max-width: 100%;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// activity.vue?76210052